interface PutOptions {
  headers?: Headers;
  params?: object;
  body?: object | string;
}

export async function get<T>(url: string, options?: RequestInit): Promise<T> {
  const { headers = {} } = options || {};
  const getOptions: RequestInit = { headers, cache: "default" };

  try {
    const res = await fetch(url, getOptions);
    const result = await res.json();
    if (!res.ok) throw new Error(result);
    return result;
  } catch (error) {
    console.log("fetch<get> failed:", error);
    throw error;
  }
}

export async function put<T>(url: string, options?: PutOptions): Promise<T> {
  const { body, ...restOptions } = options || {};
  let putOptions: RequestInit = {
    method: "POST",
    ...restOptions
  };

  if (body) {
    if (typeof body === "string") {
      putOptions.body = body;
    } else {
      putOptions.body = JSON.stringify(body);
    }
  }

  try {
    const res = await fetch(url, putOptions);
    const result = await res.json();
    if (!res.ok) throw new Error(result);
    return result;
  } catch (error) {
    console.log("fetch<put> failed:", error);
    throw error;
  }
}
